import { render, staticRenderFns } from "./e-documents-status.vue?vue&type=template&id=b2a8cc7e&lang=pug"
import script from "./e-documents-status.vue?vue&type=script&lang=js"
export * from "./e-documents-status.vue?vue&type=script&lang=js"
import style0 from "./e-documents-status.vue?vue&type=style&index=0&id=b2a8cc7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports